import { Injectable } from '@angular/core';
import { KeyboardState } from '@core/models/KeyboardState';
import { UiState, UiStore } from './ui.store';

@Injectable({ providedIn: 'root' })
export class UiService {

    constructor(private uiStore: UiStore) {
    }

    setLoading(loading: boolean): void {
        this.uiStore.update({ showLoader: loading });
    }

    setManualLoading(loading: boolean): void {
        this.uiStore.update( { showManualLoader: loading });
    }

    setSkeleton(skeleton: boolean): void {
        this.uiStore.update({ showSkeleton: skeleton });
    }

    setLabelsLoaded(labelsLoaded: boolean): void {
        this.uiStore.update({ labelsLoaded });
    }

    setKeyboardState(state: KeyboardState) {
        this.uiStore.update({ keyboardState: state });
    }

    update(uiState: Partial<UiState>): void {
        this.uiStore.update(uiState);
    }
}
